import * as Yup from 'yup';
import { ONLY_DIGITS_REGEX_ALT } from '../constants/patterns';

const BANK_CODE_LENGTH = 3;
const BANK_ACOUNT_NUM_MIN_LEN = 12;
const BANK_ACOUNT_NUM_MAX_LEN = 16;
const BANK_CODES = {
  // closed banks are commented out
  115: 'Armbusinessbank CJSC',
  118: 'ID Bank CJSC',
  151: 'Araratbank OJSC',
  157: 'Ameriabank CJSC',
  160: 'VTB Bank Armenia CJSC',
  163: 'Armeconombank OJSC',
  166: 'Evocabank CJSC',
  // 175: 'Armeconombank OJSC (BTA bank)',
  193: 'Converse Bank CJSC',
  205: 'InecoBank CJSC',
  208: 'Mellat bank CJSC',
  214: 'Byblos Bank Armenia CJSC',
  217: 'HSBC Bank Armenia CJSC',
  220: 'ACBA-Credit Agricol Bank CJSC',
  223: 'Artsakhbank CJSC',
  241: 'UniBank CJSC',
  247: 'Ardshinbank CJSC',
  250: 'ArmSwissBank CJSC',
  // 253: 'Inecobank CJSC (Procredit bank)',
  // 256: 'Panarmenian Bank OJSC',
  // 103: 'Central bank',
  248: 'Ardshinbank CJSC',
  // 248: 'Ardshinbank CJSC (Areximbank)',
  // 181: 'Ararat bank CJSC (AD bank)',
  // 0: 'Other',
  557: 'HSBC Bank Armenia CJSC (Card)',
};

export const isBankAccountValid = (value, bankCodes = BANK_CODES) => {
  if (!value) {
    return false;
  }
  if (
    value.length < BANK_ACOUNT_NUM_MIN_LEN
    || value.length > BANK_ACOUNT_NUM_MAX_LEN
  ) {
    return false;
  }
  const code = value.substring(0, BANK_CODE_LENGTH);
  const isValidBankCode = !!bankCodes[code];
  if (!isValidBankCode) {
    return false;
  }
  const accountDigits = value.substring(0, BANK_ACOUNT_NUM_MIN_LEN).split('');
  const calculatedCode = accountDigits.reduce(
    (accumulator, currentValue, currentIndex) => {
      const weight = currentIndex % 2 === 0 ? 2 : 1;
      const digitWithWeight = currentValue * weight;
      const digits = digitWithWeight.toString().split('');
      return accumulator + digits.reduce((sum, x) => sum + parseInt(x, 10), 0);
    },
    0,
  );
  return calculatedCode % 10 === 0;
};

export const isBankValid = (value, bankAccountNumber) => {
  if (!value) {
    return false;
  }
  const code = bankAccountNumber.substring(0, BANK_CODE_LENGTH);
  return code === value.code;
};

export const bankAccountSchema = Yup.string()
  .test(
    'isBankAccountValid',
    'validationErrors.invalidBankAccount',
    isBankAccountValid,
  )
  .test('isOnlyDigit', 'validationErrors.onlyDigits', (value) => ONLY_DIGITS_REGEX_ALT.test(value))
  .required('validationErrors.isRequired');
